import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { SvgIconComponent } from '@ngneat/svg-icon';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [RouterModule, SvgIconComponent],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent {
  // errorMessage: string = 'Something unexpected came up, causing a temporary issue. Please try again after a few moments.';
errorMessage: string = 'The link you are trying to access is no longer available or has expired. This could be due to the link being time-sensitive or it may have been removed. Don\'t worry, this is easy to fix. If the issue persists, please contact your admin for assistance.';

  readonly messages: Record<string, string> = {
    'invalid registration link': 'Invite links are only active for 24 hours and can be used only once.  Contact your admin to resend a new link.',
    'invalid password reset link': 'Kindly request for a new link.'
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    const params = this.route.snapshot.queryParams;
    if (params['e']) {
      const errorParam = params['e']?.toLowerCase();
      if (errorParam) {
        this.errorMessage = this.messages[errorParam] || this.toTitleCase(errorParam);
      }
      this.router.navigate([], {
        queryParams: { e: null },
        queryParamsHandling: 'merge'
      });
    }
  }

  private toTitleCase(str: string): string {
    return str.replace(/\w\S*/g, (txt) => {
      return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
    });
  }
}
